require('./hotkeys.js');
//require('./hotkeys-help.js');
